<script lang="ts">
    import { _ } from 'svelte-i18n';
    import { fade } from 'svelte/transition';

    import { debug, planning } from '../../../../stores/store';
    import ScenarioSettingsDropDown from '../../MenuDropdown/ScenarioSettingsDropDown.svelte';
    import { AssignmentManager } from './AssignmentManager';
    import Opacity from '../../../shared/Opacity.svelte';
    import RoutePlanningSummarySimple from './RoutePlanningSummarySimple.svelte';
    import { ExportTypes } from '../../Export/ExportTypes';
    import IconDownload from '../../../shared/Icons/IconDownload.svelte';
    import { features } from '../../../shared/Features/features';
    import DownloadPlanning from './DownloadPlanning.svelte';
    import DownloadDeliveryList from './DownloadDeliveryList.svelte';
    import Select from '../../../shared/Select.svelte';
    import LinkSmallBlack from '../../../shared/LinkSmallBlack.svelte';
    import IconClose from '../../../shared/Icons/IconClose.svelte';
    import { TacticalPlanApi, type TacticalPlanResponseType } from '../../TacticalPlan/TacticalPlanApi';
    import { get } from 'svelte/store';
    import { api } from '../../../../stores/api';
    import { app } from '../../../../stores/app';
    import { onMount } from 'svelte';

    export let scenarioManager: AssignmentManager;
    export let disabled: boolean = false;
    export let tacticalPlanLoaded: boolean = true;
    export let onChange: (tacticalPlanId: number, resetWithManualChange: boolean, ignoreDefinedOrder: boolean) => void;
    // export let onCreateScenario: ((tacticalPlanId: number) => void)|null = null;
    // export let onChangeScenario: ((scenarioId: number) => void)|null = null;
    export let onChangeTacticalPlanToCompare: (tacticalPlanId: number|null, withReset: boolean, ignoreDefinedOrder: boolean) => void;

    let compareToSelectorVisible: boolean = false;
    let tacticalPlans: TacticalPlanResponseType[] = [];
    let tacticalPlansToCompare: TacticalPlanResponseType[] | null = null;
    let currentTacticalPlanId: number | null = null;

    let compareScenarioDropdown;

    onMount(() => {
        Promise.all([TacticalPlanApi.getAll(get(api))])
            .then(response => {
                tacticalPlans = response[0];
                currentTacticalPlanId = scenarioManager.getTacticalPlanId();
                tacticalPlansToCompare = tacticalPlans.filter(tp => tp.id !== currentTacticalPlanId);
            })
            .catch(err => {
                console.error('Error loading tactical plans:', err);
                alert('Error loading tactical plans: ' + err);
            })
            .finally(() => {

            });
    });

    $: compareToSelectorVisible = $planning.scenarioToCompare.enabled;

    $: {
        // fix for supposed hazard, when this component is mounted at the time scenarioManager has no tactical plan set (https://er.automapa.pl/issues/52256)
        if (tacticalPlans.length && scenarioManager.getTacticalPlanId() && scenarioManager.getTacticalPlanId() !== currentTacticalPlanId) {
            currentTacticalPlanId = scenarioManager.getTacticalPlanId();
            tacticalPlansToCompare = tacticalPlans.filter(tp => tp.id !== currentTacticalPlanId);
        }
    }
</script>

{#if $debug}
    <div style="opacity: 0.4;">
        {JSON.stringify(scenarioManager.getScenario())}
    </div>
{/if}
<div style="display: flex; justify-content: space-between; align-items: center; flex: 1 0 auto;">
    <div style="text-align: left; display: {$planning.scenarioToCompare.enabled ? 'block' : 'flex'}; align-items: center; column-gap: 6px;">
        <div style="text-align: left; display: flex; align-items: center; column-gap: 6px;">
            <Opacity>
                <span style="font-size:14px;">{$_('Tactical plan')}:</span>
            </Opacity>
            {#if tacticalPlanLoaded}
                {#if scenarioManager.getTacticalPlanId()}
                    <ScenarioSettingsDropDown
                        text={($debug ? `#${scenarioManager.getTacticalPlanId()} ` : '') +
                            scenarioManager.getTacticalPlanName()}
                        bind:scenarioManager
                        selectedTacticalPlan={scenarioManager.getTacticalPlanId()}
                        {onChange}
                        {disabled}
                    />
                    <!--                    {onCreateScenario}-->
                    <!--                    {onChangeScenario}-->

                {:else}
                    <ScenarioSettingsDropDown
                        text={`(${$_('missing')})`}
                        bind:scenarioManager
                        selectedTacticalPlan={scenarioManager.getTacticalPlanId()}
                        {onChange}
                        {disabled}
                    />
                {/if}
            {/if}
        </div>
        {#if $app.account?.getSettingsReadonly()?.compare_scenarios}
            <div style="text-align: left; display: flex; align-items: center; column-gap: 6px;">
                {#if compareToSelectorVisible}
                    <div style="font-size: 14px; opacity: 1;">
                        {$_('compare_with')}
                    </div>
                    <div style="color: #4978e2">
                        <ScenarioSettingsDropDown
                            bind:this={compareScenarioDropdown}
                            text={$planning.scenarioToCompare.tacticalPlanId && tacticalPlansToCompare ? tacticalPlans.find(tp => tp.id === $planning.scenarioToCompare.tacticalPlanId)?.name || `(#${$planning.scenarioToCompare.tacticalPlanId})` : ``}
                            openText={$_('select_tactical_plan_to_compare')}
                            buttonText={$_('Compare')}
                            bind:scenarioManager
                            selectedTacticalPlan={$planning.scenarioToCompare.tacticalPlanId}
                            enableResetWithManualChanges={true}
                            enableIgnoringDefinedOrder={true}
                            disabled={tacticalPlansToCompare === null || tacticalPlansToCompare.length === 0 || disabled}
                            tacticalPlans={tacticalPlansToCompare || []}
                            onChange={(tacticalPlanId, withReset, ignoreDefinedOrder)=>{
                                console.log('ScenarioOneSettings onChange tacticalPlanId', tacticalPlanId, withReset, ignoreDefinedOrder);
                                onChangeTacticalPlanToCompare(tacticalPlanId, withReset, ignoreDefinedOrder);
                            }}
                            onClose={() => {
                                console.log('??? scenarioSettingsDropDown, onClose');
                                if (!$planning.scenarioToCompare.tacticalPlanId) {
                                    compareToSelectorVisible = false;
                                }
                            }}
                        />
                    </div>
                    <div>
                        <LinkSmallBlack text="anuluj" on:click={()=>{
                            onChangeTacticalPlanToCompare(null, false, false);
                            compareToSelectorVisible = false;
                        }} />
                    </div>
                {:else}
                    <div>
                        <LinkSmallBlack text={$_('compare')} on:click={()=>{
                            compareToSelectorVisible = true;
                            if (!$planning.scenarioToCompare.tacticalPlanId) {
                                setTimeout(function() {
                                    if (compareScenarioDropdown) {
                                        compareScenarioDropdown.handleDropdownClick();
                                    }
                                }, 0);
                            }
                    }} />
                    </div>
                {/if}
            </div>
        {/if}
    </div>
    <div style="display: flex; flex-direction: column;">
        <div style="display: flex; align-items: center; flex-direction: row; column-gap: 8px;">
            <div style="min-width: 133px;">
                <RoutePlanningSummarySimple
                    distanceMeters={scenarioManager.getDistanceMeters()}
                    durationSeconds={scenarioManager.getDurationSeconds()}
                    routeCost={scenarioManager.getRouteCost()}
                    routeCostDetails={scenarioManager.getRouteCostDetails()}
                />
            </div>
            {#if $features?.feature_planning_export_enabled}
                <div
                    class={scenarioManager.getDurationSeconds() ? '' : 'inactive'}
                >
                    <DownloadPlanning scenarioId={scenarioManager?.getScenarioId()} />
                </div>
            {/if}
            {#if $features?.feature_delivery_list_enabled}
                <div
                    class={scenarioManager.getDurationSeconds() ? '' : 'inactive'}
                >
                    <DownloadDeliveryList scenarioId={scenarioManager?.getScenarioId()} />
                </div>
            {/if}
        </div>
        {#if $planning.scenarioToCompare.enabled}
            <div style="display: flex; align-items: center; flex-direction: row; column-gap: 8px;">
                <div style="min-width: 133px;">
                    <RoutePlanningSummarySimple
                        distanceMeters={scenarioManager.getDistanceMetersToCompare()}
                        durationSeconds={scenarioManager.getDurationSecondsToCompare()}
                        routeCost={scenarioManager.getRouteCostToCompare()}
                        routeCostDetails={scenarioManager.getRouteCostDetailsToCompare()}
                        color="#4978e2"
                    />
                </div>
                <div style="flex: 1 0 auto;">
                </div>
            </div>
        {/if}
    </div>
</div>

<style>
    .inactive {
        opacity: 0.4;
        pointer-events: none;
    }
</style>
